// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"305":"baece2c6","379":"036fe285","598":"ea659e9e","635":"2039b688","741":"d9251fea","988":"d9251fea"}[chunkId] + ".chunk.css";
};